import { IKnmPlanType } from 'APIPackage/CatalogsModule/interfaces/IKnmPlanType';

import { IKnmPlanTypeOption } from '../interfaces/IKnmPlanTypeOption';

export function createKnmPlanTypeSelectOption(knmPlanType: IKnmPlanType): IKnmPlanTypeOption {
  return {
    id: knmPlanType.code,
    label: knmPlanType.name,
    value: knmPlanType.code,
    number: knmPlanType.number,
  };
}
